import createVuexModule from '~/store/utils/createVuexModule';
import type { PaginationState } from '~/types/vuex/Pagination';

export default createVuexModule<PaginationState['currentPage']>({
  stateKey: 'currentPage',
  initialValue: 1,
  mutationName: 'setCurrentPage',
});
